"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _axios = _interopRequireDefault(require("axios"));
var _basic = _interopRequireDefault(require("./_basic"));
class NluApi extends _basic.default {
  /**
   * @constructor
   */
  constructor(_ref) {
    let {
      userTokenFactory,
      fingerPrintTokenFactory,
      nluApiUrl
    } = _ref;
    super({
      userTokenFactory,
      fingerPrintTokenFactory
    });
    this.nluApiUrl = nluApiUrl;
  }
  async _paginateOverList(callList, params) {
    const queryParams = _lodash.default.clone(params);
    let last = null;
    let totalItems = [];
    let result;
    do {
      if (last) {
        queryParams.last = last;
      }
      result = await callList.call(this, queryParams);
      last = result.last;
      totalItems = _lodash.default.chain(totalItems).concat(result.items).value();
    } while (last && !_lodash.default.isEmpty(result.items));
    return totalItems;
  }
  async indexLimits() {
    const headers = await this.getHeaders();
    return _axios.default.get(`${this.nluApiUrl}/administration/limits/index`, headers).then(response => response.data);
  }
  async getLimits(path) {
    const headers = await this.getHeaders();
    return _axios.default.get(`${this.nluApiUrl}/administration/limits`, {
      ...headers,
      params: {
        path
      }
    }).then(response => response.data);
  }
  async postLimits(_ref2) {
    let {
      accountId,
      limits
    } = _ref2;
    const headers = await this.getHeaders();
    return _axios.default.post(`${this.nluApiUrl}/administration/limits`, {
      accountId,
      limits
    }, headers).then(response => response.data);
  }
  async listAllPrebuiltEntities() {
    let {
      language,
      kbId
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const headers = await this.getHeaders();
    return _axios.default.get(`${this.nluApiUrl}/kb/entities/prebuilt/all`, {
      ...headers,
      params: {
        language,
        kbId
      }
    }).then(response => response.data);
  }
  async listEntities() {
    let {
      type,
      kbId,
      versionId,
      last,
      limit
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const headers = await this.getHeaders();
    return _axios.default.get(`${this.nluApiUrl}/kb/entities/${type}`, {
      ...headers,
      params: {
        kbId,
        versionId,
        last,
        limit
      }
    }).then(response => response.data);
  }
  async listFeatures() {
    let {
      kbId,
      versionId,
      last,
      limit
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const headers = await this.getHeaders();
    return _axios.default.get(`${this.nluApiUrl}/phraselists`, {
      ...headers,
      params: {
        kbId,
        versionId,
        last,
        limit
      }
    }).then(response => response.data);
  }
  async listAllEntities() {
    let {
      type,
      versionId,
      kbId,
      limit
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return this._paginateOverList(this.listEntities, {
      type,
      kbId,
      versionId,
      limit
    });
  }
  async listAllFeatures() {
    let {
      kbId,
      versionId,
      limit
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return this._paginateOverList(this.listFeatures, {
      kbId,
      versionId,
      limit
    });
  }
  async listAllIntents() {
    let {
      kbId,
      appId,
      versionId,
      name,
      label,
      limit
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return this._paginateOverList(this.listIntents, {
      kbId,
      appId,
      versionId,
      name,
      label,
      limit
    });
  }
  async getKnowledgeModelById(_ref3) {
    let {
      kbId
    } = _ref3;
    const headers = await this.getHeaders();
    return _axios.default.get(`${this.nluApiUrl}/knowledge-base/${kbId}`, {
      ...headers
    }).then(response => response.data);
  }
  async listKnowledgeBases() {
    let {
      last,
      limit
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const headers = await this.getHeaders();
    return _axios.default.get(`${this.nluApiUrl}/knowledge-base`, {
      ...headers,
      params: {
        last,
        limit
      }
    }).then(response => response.data);
  }
  async listAllKnowledgeBases() {
    let {
      limit
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return this._paginateOverList(this.listKnowledgeBases, {
      limit
    });
  }
  async listApplications() {
    let {
      kbId,
      text,
      pattern,
      versionId,
      last,
      limit,
      projection
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const headers = await this.getHeaders();
    return _axios.default.get(`${this.nluApiUrl}/applications`, {
      ...headers,
      params: {
        kbId,
        last,
        limit,
        text,
        pattern,
        versionId,
        projection
      }
    }).then(response => response.data);
  }
  async listAllApplications() {
    let {
      kbId,
      text,
      pattern,
      versionId,
      limit,
      projection
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return this._paginateOverList(this.listApplications, {
      kbId,
      text,
      pattern,
      versionId,
      limit,
      projection
    });
  }
  async listIntentsLabels(_ref4) {
    let {
      appId
    } = _ref4;
    const headers = await this.getHeaders();
    return _axios.default.get(`${this.nluApiUrl}/intents/labels`, {
      ...headers,
      params: {
        appId
      }
    }).then(response => response.data);
  }
  async listUtterances(_ref5) {
    let {
      kbId,
      last,
      limit,
      ...query
    } = _ref5;
    const headers = await this.getHeaders();
    return _axios.default.get(`${this.nluApiUrl}/utterances`, {
      ...headers,
      params: {
        kbId,
        last,
        limit,
        ...query
      }
    }).then(response => response.data);
  }
  async getUtterancesQty(_ref6) {
    let {
      kbId
    } = _ref6;
    const headers = await this.getHeaders();
    return _axios.default.get(`${this.nluApiUrl}/knowledge-bases/${kbId}/utterances/count`, {
      ...headers
    }).then(response => response.data);
  }
  async listPatterns(_ref7) {
    let {
      kbId,
      last,
      limit,
      ...query
    } = _ref7;
    const headers = await this.getHeaders();
    return _axios.default.get(`${this.nluApiUrl}/patterns`, {
      ...headers,
      params: {
        kbId,
        last,
        limit,
        ...query
      }
    }).then(response => response.data);
  }
  async listAllUtterances(_ref8) {
    let {
      kbId,
      limit,
      ...query
    } = _ref8;
    return this._paginateOverList(this.listUtterances, {
      kbId,
      limit,
      ...query
    });
  }
  async listAllPatterns(_ref9) {
    let {
      kbId,
      limit,
      ...query
    } = _ref9;
    return this._paginateOverList(this.listPatterns, {
      kbId,
      limit,
      ...query
    });
  }
  async getPrebuiltDomains(_ref10) {
    let {
      kbId
    } = _ref10;
    const headers = await this.getHeaders();
    return _axios.default.get(`${this.nluApiUrl}/knowledge-bases/${kbId}/prebuilt-models`, {
      ...headers
    }).then(response => response.data);
  }
  async listIntents(_ref11) {
    let {
      kbId,
      appId,
      last,
      limit,
      name,
      label,
      ...query
    } = _ref11;
    const headers = await this.getHeaders();
    return _axios.default.get(`${this.nluApiUrl}/intents`, {
      ...headers,
      params: {
        kbId,
        appId,
        last,
        limit,
        name,
        label,
        ...query
      }
    }).then(response => response.data);
  }

  // TODO: delete it(for internal use)
  async createPrebuiltModel(body) {
    const headers = await this.getHeaders();
    return _axios.default.post(`${this.nluApiUrl}/prebuilt-models`, body, headers).then(response => response.data);
  }
  async getQueryReporting(_ref12) {
    let {
      kbId,
      reportingType,
      sort,
      order,
      limit,
      last
    } = _ref12;
    const headers = await this.getHeaders();
    return _axios.default.get(`${this.nluApiUrl}/reporting/queries`, {
      ...headers,
      params: {
        kbId,
        reportingType,
        sort,
        order,
        limit,
        last
      }
    }).then(response => response.data);
  }
  async removePrebuiltModelFromKM(_ref13) {
    let {
      prebuiltModelId,
      kbId
    } = _ref13;
    const headers = await this.getHeaders();
    return _axios.default.delete(`${this.nluApiUrl}/knowledge-base/prebuilt-model`, {
      ...headers,
      params: {
        prebuiltModelId,
        kbId
      }
    }).then(response => response.data);
  }
  async addPrebuiltModelToKM(_ref14) {
    let {
      kbId,
      prebuiltModelId,
      appId,
      appName,
      shouldCreateNewApplication,
      responses,
      entities
    } = _ref14;
    const headers = await this.getHeaders();
    return _axios.default.post(`${this.nluApiUrl}/knowledge-base/prebuilt-model`, {
      kbId,
      appId,
      prebuiltModelId,
      appName,
      shouldCreateNewApplication,
      responses,
      entities
    }, headers).then(response => response.data);
  }
  async getPrebuiltModelDetails(_ref15) {
    let {
      kbId,
      prebuiltModelId
    } = _ref15;
    const headers = await this.getHeaders();
    return _axios.default.get(`${this.nluApiUrl}/knowledge-base/prebuilt-model`, {
      ...headers,
      params: {
        kbId,
        prebuiltModelId
      }
    }).then(response => response.data);
  }
  async createKnowledgeBase(_ref16) {
    let {
      name,
      desc,
      imageSrc,
      config,
      culture,
      extensions,
      multilingual
    } = _ref16;
    const headers = await this.getHeaders();
    return _axios.default.post(`${this.nluApiUrl}/knowledge-base`, {
      name,
      desc,
      imageSrc,
      config,
      culture,
      extensions,
      multilingual
    }, headers).then(response => response.data);
  }
  async createApplication(_ref17) {
    let {
      kbId,
      name,
      desc,
      culture,
      model_features
    } = _ref17;
    const headers = await this.getHeaders();
    return _axios.default.post(`${this.nluApiUrl}/applications`, {
      kbId,
      name,
      desc,
      culture,
      model_features
    }, headers).then(response => response.data);
  }
  async createIntent(_ref18) {
    let {
      name,
      type,
      kbId,
      appId,
      label,
      postprocessFlows,
      customData,
      features
    } = _ref18;
    const headers = await this.getHeaders();
    return _axios.default.post(`${this.nluApiUrl}/intents`, {
      name,
      type,
      postprocessFlows,
      customData,
      features,
      label
    }, {
      ...headers,
      params: {
        kbId,
        appId
      }
    }).then(response => response.data);
  }
  async createUtterance(_ref19) {
    let {
      appId,
      kbId,
      autoGenerated,
      updatedCache,
      text,
      intent,
      entities
    } = _ref19;
    const headers = await this.getHeaders();
    return _axios.default.post(`${this.nluApiUrl}/utterances`, {
      autoGenerated,
      updatedCache,
      text,
      intent,
      entities
    }, {
      ...headers,
      params: {
        kbId,
        appId
      }
    }).then(response => response.data);
  }
  async batchCreateUtterances(_ref20) {
    let {
      appId,
      kbId,
      utterances
    } = _ref20;
    const headers = await this.getHeaders();
    return _axios.default.post(`${this.nluApiUrl}/utterances/bulk`, utterances, {
      ...headers,
      params: {
        kbId,
        appId
      }
    }).then(response => response.data);
  }
  async createPattern(_ref21) {
    let {
      appId,
      kbId,
      pattern,
      intent,
      entities
    } = _ref21;
    const headers = await this.getHeaders();
    return _axios.default.post(`${this.nluApiUrl}/patterns`, {
      pattern,
      intent,
      entities
    }, {
      ...headers,
      params: {
        kbId,
        appId
      }
    }).then(response => response.data);
  }
  async createPair(_ref22) {
    let {
      kbId,
      applicationName,
      intentName,
      intentType,
      utteranceText
    } = _ref22;
    const headers = await this.getHeaders();
    return _axios.default.post(`${this.nluApiUrl}/knowledge-base/pair`, {
      kbId,
      applicationName,
      intentName,
      intentType,
      utteranceText
    }, headers).then(response => response.data);
  }
  async batchCreatePairs(_ref23) {
    let {
      kbId,
      utterances
    } = _ref23;
    const headers = await this.getHeaders();
    return _axios.default.post(`${this.nluApiUrl}/knowledge-base/pairs`, {
      kbId,
      utterances
    }, headers).then(response => response.data);
  }
  async batchCreatePairsFile(_ref24) {
    let {
      kbId,
      fileUrl
    } = _ref24;
    const headers = await this.getHeaders();
    return _axios.default.post(`${this.nluApiUrl}/knowledge-base/pairs/file`, {
      kbId,
      fileUrl
    }, headers).then(response => response.data);
  }
  async createPatternPair(_ref25) {
    let {
      kbId,
      applicationName,
      intentName,
      intentType,
      patternText,
      patternEntities
    } = _ref25;
    const headers = await this.getHeaders();
    return _axios.default.post(`${this.nluApiUrl}/knowledge-base/patterns/pair`, {
      kbId,
      applicationName,
      intentName,
      intentType,
      patternText,
      patternEntities
    }, headers).then(response => response.data);
  }
  async createPairsCsv(_ref26) {
    let {
      kbId,
      fileUrl,
      applicationName,
      delimiter
    } = _ref26;
    const headers = await this.getHeaders();
    return _axios.default.post(`${this.nluApiUrl}/knowledge-base/pair/csv`, {
      kbId,
      applicationName,
      fileUrl,
      delimiter
    }, headers).then(response => response.data);
  }
  async createEntity(_ref27) {
    let {
      type,
      kbId,
      name,
      roles,
      ...rest
    } = _ref27;
    const headers = await this.getHeaders();
    return _axios.default.post(`${this.nluApiUrl}/kb/entities/${type}`, NluApi._getEntityBody(type, {
      name,
      roles,
      ...rest
    }), {
      ...headers,
      params: {
        kbId
      }
    }).then(response => response.data);
  }
  async createFeature(_ref28) {
    let {
      kbId,
      name,
      mode,
      words,
      enabledForAllModels
    } = _ref28;
    const headers = await this.getHeaders();
    return _axios.default.post(`${this.nluApiUrl}/phraselists`, {
      name,
      mode,
      words,
      enabledForAllModels
    }, {
      ...headers,
      params: {
        kbId
      }
    }).then(response => response.data);
  }
  async updateKnowledgeBase(knowledgeBase) {
    const headers = await this.getHeaders();
    return _axios.default.put(`${this.nluApiUrl}/knowledge-base`, knowledgeBase, headers).then(response => response.data);
  }
  async updateApplication(_ref29) {
    let {
      kbId,
      id,
      name,
      desc,
      model_features
    } = _ref29;
    const headers = await this.getHeaders();
    return _axios.default.put(`${this.nluApiUrl}/applications`, {
      kbId,
      id,
      name,
      desc,
      model_features
    }, headers).then(response => response.data);
  }
  async updateIntent(_ref30) {
    let {
      name,
      type,
      id,
      appId,
      kbId,
      postprocessFlows,
      customData,
      features,
      label
    } = _ref30;
    const headers = await this.getHeaders();
    return _axios.default.put(`${this.nluApiUrl}/intents`, {
      name,
      type,
      postprocessFlows,
      customData,
      features,
      label
    }, {
      ...headers,
      params: {
        id,
        kbId,
        appId
      }
    }).then(response => response.data);
  }
  async updateUtterance(_ref31) {
    let {
      appId,
      kbId,
      utterance
    } = _ref31;
    const headers = await this.getHeaders();
    return _axios.default.put(`${this.nluApiUrl}/utterances`, utterance, {
      ...headers,
      params: {
        kbId,
        appId
      }
    }).then(response => response.data);
  }
  async updatePattern(_ref32) {
    let {
      appId,
      kbId,
      pattern
    } = _ref32;
    const headers = await this.getHeaders();
    return _axios.default.put(`${this.nluApiUrl}/patterns`, pattern, {
      ...headers,
      params: {
        kbId,
        appId
      }
    }).then(response => response.data);
  }
  async updatePair(_ref33) {
    let {
      kbId,
      applicationName,
      intentName,
      intentType,
      utterance
    } = _ref33;
    const headers = await this.getHeaders();
    return _axios.default.put(`${this.nluApiUrl}/knowledge-base/pair`, {
      kbId,
      applicationName,
      intentName,
      intentType,
      utterance
    }, headers).then(response => response.data);
  }
  async batchUpdatePairs(_ref34) {
    let {
      kbId,
      utterances
    } = _ref34;
    const headers = await this.getHeaders();
    return _axios.default.put(`${this.nluApiUrl}/knowledge-base/pairs`, utterances, {
      ...headers,
      params: {
        kbId
      }
    }).then(response => response.data);
  }
  async updateEntity(_ref35) {
    let {
      type,
      id,
      kbId,
      name,
      roles,
      ...rest
    } = _ref35;
    const headers = await this.getHeaders();
    return _axios.default.put(`${this.nluApiUrl}/kb/entities/${type}`, NluApi._getEntityBody(type, {
      name,
      roles,
      ...rest
    }), {
      ...headers,
      params: {
        id,
        kbId
      }
    }).then(response => response.data);
  }
  async updateFeature(_ref36) {
    let {
      kbId,
      id,
      name,
      mode,
      words,
      enabledForAllModels,
      activated = true
    } = _ref36;
    const headers = await this.getHeaders();
    return _axios.default.put(`${this.nluApiUrl}/phraselists`, {
      name,
      mode,
      words,
      enabledForAllModels,
      activated
    }, {
      ...headers,
      params: {
        kbId,
        id
      }
    }).then(response => response.data);
  }
  async updatePrebuiltEntities(_ref37) {
    let {
      kbId,
      list
    } = _ref37;
    const headers = await this.getHeaders();
    return _axios.default.post(`${this.nluApiUrl}/kb/entities/prebuilt`, list, {
      ...headers,
      params: {
        kbId
      }
    }).then(response => response.data);
  }
  async deleteKnowledgeBase(_ref38) {
    let {
      id
    } = _ref38;
    const headers = await this.getHeaders();
    return _axios.default.delete(`${this.nluApiUrl}/knowledge-base`, {
      ...headers,
      params: {
        id
      }
    }).then(response => response.data);
  }
  async deleteApplication(_ref39) {
    let {
      kbId,
      appId
    } = _ref39;
    const headers = await this.getHeaders();
    return _axios.default.delete(`${this.nluApiUrl}/applications`, {
      ...headers,
      params: {
        kbId,
        appId
      }
    }).then(response => response.data);
  }
  async deleteIntent(_ref40) {
    let {
      id,
      appId,
      kbId
    } = _ref40;
    const headers = await this.getHeaders();
    return _axios.default.delete(`${this.nluApiUrl}/intents`, {
      ...headers,
      params: {
        id,
        kbId,
        appId,
        deleteUtterances: true
      }
    }).then(response => response.data);
  }
  async deleteUtterance(_ref41) {
    let {
      id,
      kbId
    } = _ref41;
    const headers = await this.getHeaders();
    return _axios.default.delete(`${this.nluApiUrl}/utterances`, {
      ...headers,
      params: {
        id,
        kbId
      }
    }).then(response => response.data);
  }
  async batchDeleteUtterances(_ref42) {
    let {
      ids,
      kbId
    } = _ref42;
    const headers = await this.getHeaders();
    return _axios.default.post(`${this.nluApiUrl}/utterances/bulk/delete`, ids, {
      ...headers,
      params: {
        kbId
      }
    }).then(response => response.data);
  }
  async deletePattern(_ref43) {
    let {
      id,
      kbId
    } = _ref43;
    const headers = await this.getHeaders();
    return _axios.default.delete(`${this.nluApiUrl}/patterns`, {
      ...headers,
      params: {
        id,
        kbId
      }
    }).then(response => response.data);
  }
  async deleteEntity(_ref44) {
    let {
      type,
      id,
      kbId
    } = _ref44;
    const headers = await this.getHeaders();
    return _axios.default.delete(`${this.nluApiUrl}/kb/entities/${type}`, {
      ...headers,
      params: {
        id,
        kbId
      }
    }).then(response => response.data);
  }
  async deleteFeature(_ref45) {
    let {
      id,
      kbId
    } = _ref45;
    const headers = await this.getHeaders();
    return _axios.default.delete(`${this.nluApiUrl}/phraselists`, {
      ...headers,
      params: {
        id,
        kbId
      }
    }).then(response => response.data);
  }
  async getTrainStatus(_ref46) {
    let {
      kbId,
      versionId = null,
      signal = null
    } = _ref46;
    const headers = await this.getHeaders();
    return _axios.default.get(`${this.nluApiUrl}/train/status`, {
      ...headers,
      params: {
        kbId,
        versionId
      },
      signal
    }).then(response => response.data);
  }
  async train(_ref47) {
    let {
      kbId,
      flowId,
      phraseId,
      sessionId,
      autoPublish
    } = _ref47;
    const headers = await this.getHeaders();
    return _axios.default.post(`${this.nluApiUrl}/kb/train`, null, {
      ...headers,
      params: {
        kbId,
        flowId,
        phraseId,
        sessionId,
        autoPublish
      }
    }).then(response => response.data);
  }
  async trainForTest(_ref48) {
    let {
      kbId,
      flowId,
      phraseId,
      sessionId
    } = _ref48;
    const headers = await this.getHeaders();
    return _axios.default.post(`${this.nluApiUrl}/kb/train/test`, null, {
      ...headers,
      params: {
        kbId,
        flowId,
        phraseId,
        sessionId
      }
    }).then(response => response.data);
  }
  async publish(_ref49) {
    let {
      kbId,
      versionId = null
    } = _ref49;
    const headers = await this.getHeaders();
    return _axios.default.post(`${this.nluApiUrl}/kb/publish`, null, {
      ...headers,
      params: {
        kbId,
        versionId
      }
    }).then(response => response.data);
  }
  async recover(_ref50) {
    let {
      kbId,
      versionId
    } = _ref50;
    const headers = await this.getHeaders();
    return _axios.default.post(`${this.nluApiUrl}/kb/recover`, null, {
      ...headers,
      params: {
        kbId,
        versionId
      }
    }).then(response => response.data);
  }
  async deleteVersion(_ref51) {
    let {
      kbId,
      versionId
    } = _ref51;
    const headers = await this.getHeaders();
    return _axios.default.delete(`${this.nluApiUrl}/knowledge-bases/${kbId}/versions/${versionId}`, {
      ...headers
    }).then(response => response.data);
  }
  async batchDeleteVersions(_ref52) {
    let {
      kbId,
      versionIds
    } = _ref52;
    const headers = await this.getHeaders();
    return _axios.default.delete(`${this.nluApiUrl}/knowledge-bases/${kbId}/versions`, {
      data: versionIds,
      ...headers
    }).then(response => response.data);
  }
  async updateVersion(_ref53) {
    let {
      kbId,
      versionId,
      name
    } = _ref53;
    const headers = await this.getHeaders();
    return _axios.default.put(`${this.nluApiUrl}/knowledge-bases/${kbId}/versions/${versionId}`, {
      name
    }, {
      ...headers
    }).then(response => response.data);
  }
  async clone(_ref54) {
    let {
      kbId,
      newName
    } = _ref54;
    const headers = await this.getHeaders();
    return _axios.default.post(`${this.nluApiUrl}/knowledge-base/clone`, {
      newName
    }, {
      ...headers,
      params: {
        id: kbId
      }
    }).then(response => response.data);
  }
  async migrateLuisToClu(_ref55) {
    let {
      kbId
    } = _ref55;
    const headers = await this.getHeaders();
    return _axios.default.post(`${this.nluApiUrl}/knowledge-base/${kbId}/migrate-luis-to-clu`, null, headers).then(response => response.data);
  }
  async export(_ref56) {
    let {
      kbId,
      isPublic,
      exclude
    } = _ref56;
    const headers = await this.getHeaders();
    return _axios.default.get(`${this.nluApiUrl}/knowledge-base/export`, {
      ...headers,
      params: {
        id: kbId,
        isPublic,
        exclude
      }
    }).then(response => response.data);
  }
  async import(_ref57) {
    let {
      fileUrl,
      knowledgeBase
    } = _ref57;
    const headers = await this.getHeaders();
    return _axios.default.post(`${this.nluApiUrl}/knowledge-base/import`, {
      fileUrl,
      knowledgeBase
    }, headers).then(response => response.data);
  }
  async importJson(data) {
    const headers = await this.getHeaders();
    return _axios.default.post(`${this.nluApiUrl}/knowledge-base/import/json`, data, headers).then(response => response.data);
  }
  async importCsv(_ref58) {
    let {
      fileUrl,
      knowledgeBase,
      applicationName,
      delimiter
    } = _ref58;
    const headers = await this.getHeaders();
    return _axios.default.post(`${this.nluApiUrl}/knowledge-base/import/csv`, {
      fileUrl,
      knowledgeBase,
      applicationName,
      delimiter
    }, headers).then(response => response.data);
  }
  async getProvisioningStatus(_ref59) {
    let {
      appId,
      kbId
    } = _ref59;
    const headers = await this.getHeaders();
    return _axios.default.get(`${this.nluApiUrl}/provisioning/status`, {
      ...headers,
      params: {
        kbId,
        appId
      }
    }).then(response => response.data);
  }
  async updateProvisioningStatus(_ref60) {
    let {
      accountId,
      applicationId,
      status,
      kbId,
      isKb
    } = _ref60;
    const headers = await this.getHeaders();
    return _axios.default.put(`${this.nluApiUrl}/provisioning/status`, {
      accountId,
      applicationId,
      status,
      kbId,
      isKb
    }, headers).then(response => response.data);
  }
  async meaning(data) {
    const headers = await this.getHeaders();
    return _axios.default.post(`${this.nluApiUrl}/meaning`, data, headers).then(response => response.data);
  }
  async createContext(data) {
    const headers = await this.getHeaders();
    return _axios.default.post(`${this.nluApiUrl}/applications`, data, headers).then(response => response.data);
  }
  async mergeContexts(_ref61) {
    let {
      kbId,
      targetContext,
      mergingContextsIds
    } = _ref61;
    const headers = await this.getHeaders();
    return _axios.default.post(`${this.nluApiUrl}/applications/merge`, {
      kbId,
      targetContext,
      mergingContextsIds
    }, headers).then(response => response.data);
  }
  async mergeIntents(_ref62) {
    let {
      kbId,
      appId,
      targetIntent,
      mergingIntentsIds
    } = _ref62;
    const headers = await this.getHeaders();
    return _axios.default.post(`${this.nluApiUrl}/intents/merge`, {
      kbId,
      appId,
      targetIntent,
      mergingIntentsIds
    }, headers).then(response => response.data);
  }
  async testMeaning(_ref63) {
    let {
      q,
      appId,
      kbId
    } = _ref63;
    const headers = await this.getHeaders();
    return _axios.default.post(`${this.nluApiUrl}/meaning/test`, {
      q,
      appId,
      kbId
    }, headers).then(response => response.data);
  }
  async qnaMeaning(_ref64) {
    let {
      q,
      appId,
      kbId,
      isKb
    } = _ref64;
    const headers = await this.getHeaders();
    return _axios.default.post(`${this.nluApiUrl}/qna/meaning`, {
      q,
      appId,
      kbId,
      isKb
    }, headers).then(response => response.data);
  }
  async getLogs(_ref65) {
    let {
      kbId,
      search,
      start,
      end,
      last
    } = _ref65;
    const headers = await this.getHeaders();
    return _axios.default.get(`${this.nluApiUrl}/events`, {
      ...headers,
      params: {
        kbId,
        search,
        start,
        end,
        last
      }
    }).then(response => response.data);
  }
  async deleteLogs(_ref66) {
    let {
      kbId,
      search,
      start,
      end
    } = _ref66;
    const headers = await this.getHeaders();
    return _axios.default.delete(`${this.nluApiUrl}/events`, {
      ...headers,
      params: {
        kbId,
        search,
        start,
        end
      }
    }).then(response => response.data);
  }
  static _getEntityBody(type, data) {
    const base = {
      name: data.name,
      roles: data.roles
    };
    switch (type) {
      case 'simple':
        return {
          ...base,
          features: data.features,
          children: data.children
        };
      case 'regex':
        return {
          ...base,
          regexPattern: data.regexPattern
        };
      case 'prebuilt':
        return base;
      case 'postprocess':
        return {
          name: data.name,
          processFlow: data.processFlow
        };
      case 'list':
        return {
          ...base,
          subLists: data.subLists
        };
      case 'patternany':
        return base;
      default:
        throw new Error(`Unknown entity type ${type}`);
    }
  }
}
var _default = NluApi;
exports.default = _default;